import { AttackPattern, PatternState } from '../AttackPattern.js';
import { ARENA } from '../../../../config/constants.js';

// A temporary wall removes a lane of the arena, but always leaves a clear gap.
export class ThroneDivide extends AttackPattern {
  constructor({ config }) {
    super({ name: 'Throne Divide', telegraphDuration: 1.0, activeDuration: 2.2, minPhase: 0, arenaControl: true });
    this.config = config;
  }

  onBegin(boss) {
    this._vertical = boss.phase < 2;
    this._offset = boss.phase >= 1 ? 0.35 : 0.5;
    this._gap = this.config.gapSize;
    this._hitTimer = 0;
  }

  onActiveTick(dt, _boss, player) {
    this._hitTimer -= dt;
    const center = this._vertical ? ARENA.x + ARENA.width * this._offset : ARENA.y + ARENA.height * this._offset;
    const coordinate = this._vertical ? player.x : player.y;
    const span = this._vertical ? ARENA.height : ARENA.width;
    const along = this._vertical ? player.y : player.x;
    const gapCenter = (this._vertical ? ARENA.y : ARENA.x) + span * 0.5;
    const inWall = Math.abs(coordinate - center) < this.config.width / 2 && Math.abs(along - gapCenter) > this._gap / 2;
    if (inWall && this._hitTimer <= 0) {
      player.takeDamage(this.config.damage);
      this._hitTimer = 0.5;
    }
  }

  onEnd(boss) { boss.openVulnerability(0.75, 1.6); }

  getVisual() {
    if (this.state !== PatternState.TELEGRAPH && this.state !== PatternState.ACTIVE) return null;
    return { kind: 'throneDivide', vertical: this._vertical, offset: this._offset, width: this.config.width, gap: this._gap, active: this.state === PatternState.ACTIVE };
  }
}
